import toast from "react-hot-toast"
import { ConvertEnglish } from "../../components/ConterEnglsih"


export const customerApiPost = (bodyInfo) =>{
    fetch(`https://amar-dish-server.vercel.app/customer`,{
        method:"POST",
        headers :{
            "content-type" : "application/json"
        },
        body : JSON.stringify(bodyInfo)
    })
    .then(res => res.json())
     .then(customerData => {
        // console.log(customerData)
        // if(customerData === "Already Have"){
        //     return  toast.error("এই আইডি আগে থেকেই আছে")
        // }
        if(customerData.acknowledged){
            toast.success("গ্রাহক সংযোগ সফল হয়েছে")
        }
 
       
    })
}

